import React, { useState, useEffect, useContext, useMemo } from "react";
import { AuthContext } from "../../contexts/AuthContext";
import Header from "../../layout/Header/Header";
import {
  Button,
  Row,
  Table,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  Label,
  ButtonGroup,
  Col,
  Spinner,
  Form,
} from "reactstrap";
import SweetAlert from "sweetalert2-react";
import Swal from "sweetalert2";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import autoTable from "jspdf-autotable";
import ExportJsonExcel from "js-export-excel";
import { encode } from "base64-arraybuffer";
import axios from "axios";
import { TableHeader, Pagination, Search } from "../../DataTable";
import useFullPageLoader from "../../hooks/useFullPageLoader";
import qrcode from "qrcode-js";
import moment from "moment";
import { v4 as uuidv4 } from "uuid";

function CorteDiario() {
  const { user } = useContext(AuthContext);
  const URL_CORTE_DIARIO = process.env.REACT_APP_URL_CORTE_DIARIO;
  const URL_SEND_MAIL_ATT = process.env.REACT_APP_URL_SEND_MAIL_ATT;
  const URL_PROVEEDORES = process.env.REACT_APP_URL_PROVEEDORES;
  const URL_CLIENTES = process.env.REACT_APP_URL_CLIENTES;
  const URL_COLORES = process.env.REACT_APP_URL_COLORES;
  const URL_TELAS = process.env.REACT_APP_URL_TELAS;

  let hoy = new Date();
  let endDate = moment(hoy).format("YYYY-MM-DD");

  const [selectedFechaInicio, setSelectedFechaInicio] = useState(endDate);
  const [selectedFechaFin, setSelectedFechaFin] = useState(endDate);

  const [proveedores, setProveedores] = useState([]);
  const [selectedProveedor, setSelectedProveedor] = useState("");
  const [selectedProveedorCompras, setSelectedProveedorCompras] = useState("");

  const [clientes, setClientes] = useState([]);
  const [selectedCliente, setSelectedCliente] = useState("");

  const [colores, setColores] = useState([]);
  const [selectedColor, setSelectedColor] = useState("");
  const [selectedColorCompras, setSelectedColorCompras] = useState("");
  const [telas, setTelas] = useState([]);
  const [selectedTela, setSelectedTela] = useState("");
  const [selectedTelaCompras, setSelectedTelaCompras] = useState("");

  const [corteDiarioCortes, setCorteDiarioCortes] = useState([]);
  const [corteDiarioCompras, setCorteDiarioCompras] = useState([]);
  const [corteDiarioDevPro, setCorteDiarioDevPro] = useState([]);

  // (2026-08) Qué movimientos se muestran: Todos, Cortes, Compras o Devoluciones.
  // Aplica igual a las tablas y al Excel.
  const [selectedMovimiento, setSelectedMovimiento] = useState("Todos");
  const verCortes =
    selectedMovimiento === "Todos" || selectedMovimiento === "Cortes";
  const verCompras =
    selectedMovimiento === "Todos" || selectedMovimiento === "Compras";
  const verDevoluciones =
    selectedMovimiento === "Todos" || selectedMovimiento === "Devoluciones";

  useMemo(() => {
    axios
      .get(`${URL_CORTE_DIARIO}/${selectedFechaInicio}/${selectedFechaFin}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allCorteDiarioCortes = response.data.dataCortes;
        setCorteDiarioCortes(allCorteDiarioCortes);

        let allCorteDiarioCompras = response.data.dataCompras;
        setCorteDiarioCompras(allCorteDiarioCompras);

        let allCorteDiarioDevPro = response.data.dataDevPro;
        setCorteDiarioDevPro(allCorteDiarioDevPro);
      })
      .catch((err) => {
        console.log(err);
      });

       axios
            .get(URL_PROVEEDORES, {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            })
            .then((response) => {
              let allProveedores = response.data;
              setProveedores(allProveedores);
            })
            .catch((err) => {
              console.log(err);
            });

            axios
            .get(URL_CLIENTES, {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            })
            .then((response) => {
              let allClientes = response.data;
              setClientes(allClientes);
            })
            .catch((err) => {
              console.log(err);
            });
            axios
            .get(URL_COLORES, {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            })
            .then((response) => {
              let allColores = response.data;
              setColores(allColores);
            })
            .catch((err) => {
              console.log(err);
            });
            axios
            .get(URL_TELAS, {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            })
            .then((response) => {
              let allTelas = response.data;
              setTelas(allTelas);
            })
            .catch((err) => {
              console.log(err);
            });
  }, [selectedFechaInicio, selectedFechaFin]);

  function excel() {
    const dataExcelCortes = corteDiarioCortes.map((a) => {
      if (
        (selectedCliente == 0 || selectedCliente == a.idCliente) &&
        (selectedColor == 0 || selectedColor == a.idColor) &&
        (selectedTela == 0 || selectedTela == a.idTela)
      ) {
      return {
        Fecha: a.fecha,
        Proveedor: a.proveedor,
        Cliente: a.cliente,
        Tela: a.tela,
        Color: a.color,
        Cantidad: a.cantidad,
        Precio: a.precio,
        Total: a.total,
      }
    }
    });
    const dataExportExcelCortes = Object.values(dataExcelCortes);
    const dataExcelCortesLimpia = dataExportExcelCortes.filter(function (el) {
      return el != null;
    });

    const dataExcelCompras = corteDiarioCompras.map((a) => {
      if (
        (selectedProveedorCompras == 0 || selectedProveedorCompras == a.idProveedor) &&
        (selectedColorCompras == 0 || selectedColorCompras == a.idColor) &&
        (selectedTelaCompras == 0 || selectedTelaCompras == a.idTela)
      ) {
      return {
        Fecha: a.fecha,
        Compra: a.compra,
        Proveedor: a.proveedor,
        Tela: a.tela,
        Color: a.color,
        Cantidad: a.cantidad,
        Precio: a.precio,
        Total: a.total,
      }
    }
    });
    const dataExportExcelCompras = Object.values(dataExcelCompras);
    const dataExcelComprasLimpia = dataExportExcelCompras.filter(function (el) {
      return el != null;
    });


    const dataExcelDevProveedor = corteDiarioDevPro.map((a) => {
      return {
        Fecha: a.fecha,
        Devolucion: a.devolucion,
        Proveedor: a.proveedor,
        Tela: a.tela,
        Color: a.color,
        Cantidad: a.cantidad,
        Precio: a.precio,
        Total: a.total,
      };
    });
    const dataExportExcelDevProveedor = Object.values(dataExcelDevProveedor);
    const dataExcelDevProveedorLimpia = dataExportExcelDevProveedor.filter(
      function (el) {
        return el != null;
      }
    );

    var option = {};

    option.fileName = "CorteDiario";

    // (2026-08) El Excel solo trae las hojas de los movimientos seleccionados
    option.datas = [
      verCortes && {
        sheetData: dataExcelCortesLimpia,
        sheetName: "Cortes",
        sheetFilter: [
          "Fecha",
          "Proveedor",
          "Cliente",
          "Tela",
          "Color",
          "Cantidad",
          "Precio",
          "Total",
        ],
        sheetHeader: [
          "Fecha",
          "Proveedor",
          "Cliente",
          "Tela",
          "Color",
          "Cantidad",
          "Precio",
          "Total",
        ],
      },

      verCompras && {
        sheetData: dataExcelComprasLimpia,
        sheetName: "Compras",
        sheetFilter: [
          "Fecha",
          "Compra",
          "Proveedor",
          "Tela",
          "Color",
          "Cantidad",
          "Precio",
          "Total",
        ],
        sheetHeader: [
          "Fecha",
          "Compra",
          "Proveedor",
          "Tela",
          "Color",
          "Cantidad",
          "Precio",
          "Total",
        ],
      },

      verDevoluciones && {
        sheetData: dataExcelDevProveedorLimpia,
        sheetName: "DevProveedor",
        sheetFilter: [
          "Fecha",
          "Devolucion",
          "Proveedor",
          "Tela",
          "Color",
          "Cantidad",
          "Precio",
          "Total",
        ],
        sheetHeader: [
          "Fecha",
          "Devolucion",
          "Proveedor",
          "Tela",
          "Color",
          "Cantidad",
          "Precio",
          "Total",
        ],
      },
    ].filter(Boolean);

    var toExcel = new ExportJsonExcel(option);
    toExcel.saveExcel();
  }

  let totalCortesDinero = 0;
  let totalCortesMetros = 0;
  let totalComprasDinero = 0;
  let totalComprasMetros = 0;
  let totalDevProDinero = 0;
  let totalDevProMetros = 0;
  return (
    <>
      <Header />
      <br />
      <br />
      {user.menu_compras ? (
        <div className="card container col-11">
          <Row>
            <Col md={8}>
              <Button
                size="sm"
                href="/MenuReportes"
                className="btn btn-danger"
                id="botonListado"
              >
                Regresar
              </Button>
            </Col>
            <Col sm={4}>
              <ButtonGroup id="logoutBoton">
                <Button
                  size="sm"
                  className="btn"
                  color="primary"
                  onClick={excel}
                >
                  Excel <i class="far fa-file-excel"></i>
                </Button>
              </ButtonGroup>
            </Col>
          </Row>
          <h3 align="center"> Reporte Telas</h3>
          <Row>
            <Col md={2}>
              <Label className="mr-sm-2">Fecha Inicio</Label>
              <Input
                bsSize="sm"
                type="date"
                value={selectedFechaInicio}
                required
                onChange={(e) => {
                  setSelectedFechaInicio(e.target.value);
                }}
              />
            </Col>
            <Col md={2}>
              <Label className="mr-sm-2">Fecha Fin</Label>
              <Input
                bsSize="sm"
                type="date"
                value={selectedFechaFin}
                required
                onChange={(e) => {
                  setSelectedFechaFin(e.target.value);
                }}
              />
            </Col>
            {/* (2026-08) Qué movimientos se ven (también aplica al Excel) */}
            <Col md={2}>
              <Label className="mr-sm-2">Movimientos</Label>
              <Input
                bsSize="sm"
                type="select"
                value={selectedMovimiento}
                onChange={(e) => {
                  setSelectedMovimiento(e.target.value);
                }}
              >
                <option value="Todos">Todos</option>
                <option value="Cortes">Cortes</option>
                <option value="Compras">Compras</option>
                <option value="Devoluciones">Devoluciones</option>
              </Input>
            </Col>
          </Row>
          <br />
          <Table size="sm" striped borderless className="table-responsive-xl">
            {/* Cortes */}
            {verCortes && (
            <tbody>
              <tr>
                <th>CORTES</th>
                
                <th>
                <Input
                    bsSize="sm"
                    type="select"
                    value={selectedProveedor}
                    onChange={(e) => {
                      setSelectedProveedor(e.target.value);
                    }}
                  >
                    <option value="0">Selecciona</option>
                    {proveedores
                      .sort((a, b) =>
                        a.nombre_comercial > b.nombre_comercial ? 1 : -1
                      )
                      .map((a) => {
                        return <option value={a._id}>{a.nombre_comercial}</option>;
                      })}
                  </Input>
                </th>
                <th>
                <Input
                    bsSize="sm"
                    type="select"
                    value={selectedCliente}
                    onChange={(e) => {
                      setSelectedCliente(e.target.value);
                    }}
                  >
                    <option value="0">Selecciona</option>
                    {clientes
                      .sort((a, b) =>
                        a.nombre_comercial > b.nombre_comercial ? 1 : -1
                      )
                      .map((a) => {
                        return <option value={a._id}>{a.nombre_comercial}</option>;
                      })}
                  </Input>
                </th>
                <th>
                <Input
                    bsSize="sm"
                    type="select"
                    value={selectedTela}
                    onChange={(e) => {
                      setSelectedTela(e.target.value);
                    }}
                  >
                    <option value="0">Selecciona</option>
                    {telas
                      .sort((a, b) =>
                        a.codigo > b.codigo ? 1 : -1
                      )
                      .map((a) => {
                        return <option value={a._id}>{a.codigo} {a.nombre}</option>;
                      })}
                  </Input>
                </th>
                <th>
                <Input
                    bsSize="sm"
                    type="select"
                    value={selectedColor}
                    onChange={(e) => {
                      setSelectedColor(e.target.value);
                    }}
                  >
                    <option value="0">Selecciona</option>
                    {colores
                      .sort((a, b) =>
                        a.name > b.name ? 1 : -1
                      )
                      .map((a) => {
                        return <option value={a._id}>{a.name}</option>;
                      })}
                  </Input>
                </th>
                <th></th>
                <th></th>
                <th></th>
              </tr>
              <tr>
                <th>Fecha</th>
                <th>Proveedor</th>
                <th>Cliente</th>
                <th>Tela</th>
                <th>Color</th>
                <th>Cantidad</th>
                <th>Precio</th>
                <th>Total</th>
              </tr>
              {corteDiarioCortes.map((a) => {
                     if ((
                      selectedCliente == 0 ||
                      selectedCliente == a.idCliente
                    ) &&
                (selectedColor == 0 || selectedColor == a.idColor) &&
                (selectedTela == 0 || selectedTela == a.idTela) &&
                    (selectedProveedor == 0 || selectedProveedor == a.idProveedor)){
                // {commentsData.map((a) => {
                {
                  totalCortesMetros = totalCortesMetros + a.cantidad;
                  totalCortesDinero = totalCortesDinero + a.total;
                  return (
                    <tr>
                      <td>{a.fecha}</td>
                      <td>{a.proveedor}</td>
                      <td>{a.cliente}</td>
                      <td>{a.tela}</td>
                      <td>{a.color}</td>
                      <td>
                        {new Intl.NumberFormat("en-US", {
                          // style: "currency",
                          // currency: "USD",
                          maximumFractionDigits: 2,
                        }).format(a.cantidad)}
                      </td>
                      <td>
                        {new Intl.NumberFormat("en-US", {
                          style: "currency",
                          currency: "USD",
                          maximumFractionDigits: 2,
                        }).format(a.precio)}
                      </td>
                      <td>
                        {new Intl.NumberFormat("en-US", {
                          style: "currency",
                          currency: "USD",
                          maximumFractionDigits: 2,
                        }).format(a.total)}
                      </td>
                    </tr>
                  );
                }
              }
              })}

              <tr>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td className="negrita">TOTAL</td>
                <td className="negrita">
                  {new Intl.NumberFormat("en-US", {
                    maximumFractionDigits: 2,
                  }).format(totalCortesMetros)}
                </td>
                <td></td>
                <td className="negrita">
                  {new Intl.NumberFormat("en-US", {
                    style: "currency",
                    currency: "USD",
                    maximumFractionDigits: 2,
                  }).format(totalCortesDinero)}
                </td>
              </tr>
            </tbody>
            )}
            <br />
            <br />
            {/* Compras */}
            {verCompras && (
            <tbody>
              <tr>
                <th>COMPRAS</th>
                <th></th>
                <th>
                  <Input
                    bsSize="sm"
                    type="select"
                    value={selectedProveedorCompras}
                    onChange={(e) => {
                      setSelectedProveedorCompras(e.target.value);
                    }}
                  >
                    <option value="0">Selecciona</option>
                    {proveedores
                      .sort((a, b) =>
                        a.nombre_comercial > b.nombre_comercial ? 1 : -1
                      )
                      .map((a) => {
                        return <option value={a._id}>{a.nombre_comercial}</option>;
                      })}
                  </Input>
                </th>
                <th>
                <Input
                    bsSize="sm"
                    type="select"
                    value={selectedTelaCompras}
                    onChange={(e) => {
                      setSelectedTelaCompras(e.target.value);
                    }}
                  >
                    <option value="0">Selecciona</option>
                    {telas
                      .sort((a, b) =>
                        a.codigo > b.codigo ? 1 : -1
                      )
                      .map((a) => {
                        return <option value={a._id}>{a.codigo} {a.nombre}</option>;
                      })}
                  </Input>
                </th>
                <th>
                <Input
                    bsSize="sm"
                    type="select"
                    value={selectedColorCompras}
                    onChange={(e) => {
                      setSelectedColorCompras(e.target.value);
                    }}
                  >
                    <option value="0">Selecciona</option>
                    {colores
                      .sort((a, b) =>
                        a.name > b.name ? 1 : -1
                      )
                      .map((a) => {
                        return <option value={a._id}>{a.name}</option>;
                      })}
                  </Input>
                </th>
                <th></th>
                <th></th>
                <th></th>
              </tr>
              <tr>
                <th>Fecha</th>
                <th>Compra</th>
                <th>Proveedor</th>
                <th>Tela</th>
                <th>Color</th>
                <th>Cantidad</th>
                <th>Precio</th>
                <th>Total</th>
              </tr>
              {corteDiarioCompras.map((a) => {
                if ((
                  selectedProveedorCompras == 0 ||
                  selectedProveedorCompras == a.idProveedor
                )&&
                (selectedColorCompras == 0 || selectedColorCompras == a.idColor) &&
                (selectedTelaCompras == 0 || selectedTelaCompras == a.idTela)
              ) {
                  // {commentsData.map((a) => {
                  totalComprasDinero = totalComprasDinero + a.total;
                  totalComprasMetros = totalComprasMetros + a.cantidad;
                  return (
                    <tr>
                      <td>{a.fecha}</td>
                      <td>{a.compra}</td>
                      <td>{a.proveedor}</td>
                      <td>{a.tela}</td>
                      <td>{a.color}</td>
                      <td>
                        {new Intl.NumberFormat("en-US", {
                          // style: "currency",
                          // currency: "USD",
                          maximumFractionDigits: 2,
                        }).format(a.cantidad)}
                      </td>
                      <td>
                        {new Intl.NumberFormat("en-US", {
                          style: "currency",
                          currency: "USD",
                          maximumFractionDigits: 2,
                        }).format(a.precio)}
                      </td>
                      <td>
                        {new Intl.NumberFormat("en-US", {
                          style: "currency",
                          currency: "USD",
                          maximumFractionDigits: 2,
                        }).format(a.total)}
                      </td>
                    </tr>
                  );
                }
              })}

              <tr>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td className="negrita">TOTAL</td>
                <td className="negrita">
                  {new Intl.NumberFormat("en-US", {
                    maximumFractionDigits: 2,
                  }).format(totalComprasMetros)}
                </td>
                <td></td>
                <td className="negrita">
                  {new Intl.NumberFormat("en-US", {
                    style: "currency",
                    currency: "USD",
                    maximumFractionDigits: 2,
                  }).format(totalComprasDinero)}
                </td>
              </tr>
            </tbody>
            )}
            <br />
            <br />

            {/* DEVOLUCIONES PROVEEDORES */}
            {verDevoluciones && (
            <tbody>
              <tr>
                <th>DEVOLUCIONES PROVEEDORES</th>
                <th></th>
                <th></th>
                <th></th>
                <th></th>
                <th></th>
                <th></th>
                <th></th>
              </tr>
              <tr>
                <th>Fecha</th>
                <th>Devolucion</th>
                <th>Proveedor</th>
                <th>Tela</th>
                <th>Color</th>
                <th>Cantidad</th>
                <th>Precio</th>
                <th>Total</th>
              </tr>
              {corteDiarioDevPro.map((a) => {
                // {commentsData.map((a) => {
                {
                  totalDevProDinero = totalDevProDinero + a.total;
                  totalDevProMetros = totalDevProMetros + a.cantidad;
                  return (
                    <tr>
                      <td>{a.fecha}</td>
                      <td>{a.devolucion}</td>
                      <td>{a.proveedor}</td>
                      <td>{a.tela}</td>
                      <td>{a.color}</td>
                      <td>
                        {new Intl.NumberFormat("en-US", {
                          // style: "currency",
                          // currency: "USD",
                          maximumFractionDigits: 2,
                        }).format(a.cantidad)}
                      </td>
                      <td>
                        {new Intl.NumberFormat("en-US", {
                          style: "currency",
                          currency: "USD",
                          maximumFractionDigits: 2,
                        }).format(a.precio)}
                      </td>
                      <td>
                        {new Intl.NumberFormat("en-US", {
                          style: "currency",
                          currency: "USD",
                          maximumFractionDigits: 2,
                        }).format(a.total)}
                      </td>
                    </tr>
                  );
                }
              })}

              <tr>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td className="negrita">TOTAL</td>
                <td className="negrita">
                  {new Intl.NumberFormat("en-US", {
                    maximumFractionDigits: 2,
                  }).format(totalDevProMetros)}
                </td>
                <td></td>
                <td className="negrita">
                  {new Intl.NumberFormat("en-US", {
                    style: "currency",
                    currency: "USD",
                    maximumFractionDigits: 2,
                  }).format(totalDevProDinero)}
                </td>
              </tr>
            </tbody>
            )}
            <br />
            <br />
          </Table>
        </div>
      ) : undefined}
      <br />
    </>
  );
}

export default CorteDiario;
